var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$hasModuleAccess(_vm.MODULES.papu_3))?_c('OrdersMapPapu3'):_c('OrdersMap')
}
var staticRenderFns = []

export { render, staticRenderFns }